module.exports = __webpack_public_path__ + "img/background_blue_sky.1a1996cf.svg";